module.exports = "/_next/static/images/42106fdca3ed00a4cb4165e38339f443-frozen-icon.svg";